import type { PartnerUser } from '../../lib/api';

/** A contact read back in the partner's own identifiers — Reach's internal UUID is never shown. */
export const contactLabel = (contact: PartnerUser): string => {
  const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(' ');
  const identifiers = [contact.email, contact.phone].filter(Boolean);
  const externalIdLabel = contact.externalId ? `External ID: ${contact.externalId}` : '';
  const recognizableName = fullName || identifiers[0] || contact.externalId;
  const context = [...identifiers, externalIdLabel]
    .filter(identifier => Boolean(identifier) && identifier !== recognizableName)
    .join(' · ');
  return context ? `${recognizableName} — ${context}` : recognizableName;
};
